import {Button, Stack, Typography} from '@mui/material';
import React from 'react';

import {IconIllustration} from 'presentation/components';
import {Modal as ModalComponent} from 'presentation/components/Modal';
import {translations} from 'presentation/translations-new';
import {ModalProps} from './types';

const {cancel, exclude} = translations['pt-br'].commons;
export const ConfirmActionModal = ({
	open,
	setOpen,
	onConfirm,
	title,
	text,
	description,
	modalDataTagId,
	closeButtonDataTagId,
	cancelButtonDataTagId,
	confirmButtonDataTagId,
}: ModalProps) => (
	<ModalComponent.Root open={open} onClose={() => setOpen(false)}>
		<ModalComponent.Header
			title={title}
			onClose={() => setOpen(false)}
			closeBtnDataTagId={closeButtonDataTagId}
		/>
		<Stack justifyContent="center" direction="row" mt={3} data-tag-id={modalDataTagId}>
			<IconIllustration variant="info" />
		</Stack>
		<ModalComponent.Content>
			<Typography variant="h6" textAlign="center">
				{text}
			</Typography>
			<Typography variant="body1" marginTop={2} textAlign="center">
				{description}
			</Typography>
		</ModalComponent.Content>

		<ModalComponent.Footer>
			<Stack spacing={1} direction="row" width="100%">
				<Button
					fullWidth
					variant="outlined"
					onClick={() => setOpen(false)}
					data-tag-id={cancelButtonDataTagId}>
					{cancel}
				</Button>
				<Button
					fullWidth
					variant="outlined"
					color="error"
					onClick={onConfirm}
					data-tag-id={confirmButtonDataTagId}>
					{exclude}
				</Button>
			</Stack>
		</ModalComponent.Footer>
	</ModalComponent.Root>
);
